// we'll have to write like this way, otherwise browser won't load because of cross origin error
const timerWorker = `
const timeoutIds = new Map();
self.onmessage = (event) => {
  if (event.data.timeoutMs !== undefined) {
    const timeoutId = self.setTimeout(() => {
      self.postMessage({ callbackId: event.data.callbackId });
      timeoutIds.delete(event.data.callbackId);
    }, event.data.timeoutMs);
    timeoutIds.set(event.data.callbackId, timeoutId);
  } else {
    const timeoutId = timeoutIds.get(event.data.callbackId);
    self.clearTimeout(timeoutId);
    timeoutIds.delete(event.data.callbackId);
  }
};
`;
export function createTimerWorker() {
    const callbacks = new Map();
    const worker = new Worker(URL.createObjectURL(new Blob([timerWorker], { type: 'text/javascript' })));
    worker.onmessage = (event) => {
        const callback = callbacks.get(event.data.callbackId);
        if (!callback) {
            return;
        }
        callbacks.delete(event.data.callbackId);
        callback();
    };
    let nextCallbackId = 1;
    function setTimeout(callback, timeoutMs = 0) {
        const callbackId = nextCallbackId++;
        callbacks.set(callbackId, callback);
        worker.postMessage({ callbackId, timeoutMs });
        return callbackId;
    }
    function clearTimeout(callbackId) {
        if (!callbacks.has(callbackId)) {
            return;
        }
        worker.postMessage({ callbackId });
        callbacks.delete(callbackId);
    }
    function terminate() {
        callbacks.clear();
        worker.terminate();
    }
    return { setTimeout, clearTimeout, terminate };
}
